/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import {Box, IconButton} from '@material-ui/core';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import WebIcon from '@material-ui/icons/Web';
import Tooltip from '@material-ui/core/Tooltip';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  mainBox: {
    margin: '15px',
    [theme.breakpoints.down('700')]: {
      margin: '0',
    },
  },
  root: {
    display: 'flex',
    width: '100%',
  },
  details: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  fontSizeP: {
    [theme.breakpoints.down('700')]: {
      fontSize: '12px',
    },
  },
  previewContainer: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    margin: '10px',
    width: '25%',
    [theme.breakpoints.down('700')]: {
      width: '40%',
      margin: 1,
    },
  },
  nameContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignContent: 'center',
    alignItems: 'center',
    margin: '10px',
    width: '30%',
    [theme.breakpoints.down('700')]: {
      display: 'none',
    },
    color: '#fff',
  },
  urlContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignContent: 'center',
    alignItems: 'center',
    margin: '10px',
    width: '30%',
    [theme.breakpoints.down('700')]: {
      width: '40%',
      justifyContent: 'center',
    },
    color: '#fff',
  },
  optionsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
    margin: '10px',
    width: '20%',
    [theme.breakpoints.down('700')]: {
      width: '10%',
      flexDirection: 'column',
    },
  },
  iconButtonStyle: {
    height: '50px',
  },
}));

export default function ListPageData({
  name, url, editorSelect, clone, idPageItem, idPageOrigin,
}) {
  const limitText = (text) => {
    // const limit = 20;
    if (text.length > 20) {
      const textBreak = text.split('/').map((item) => {
        if (item !== '') {
          return (
            <>
              {`/${item}`}
              <br />
            </>
          );
        }
        return (
          <></>
        );
      });
      return textBreak;
      // return `${text.substr(0, limit)}...`;
    }
    return text;
  };
  const classes = useStyles();
  return (
    <Box component="div" className={classes.mainBox}>
      <Card className={classes.root} style={{background: idPageItem === idPageOrigin ? 'rgba(113, 112, 112, 1)' : '#242424'}}>
        <Box component="div" className={classes.details}>
          <Box className={classes.nameContainer}>
            <Typography>
              {name}
            </Typography>
          </Box>
          <Box className={classes.urlContainer}>
            <Typography className={classes.fontSizeP}>
              {limitText(url)}
            </Typography>
          </Box>
          <Box className={classes.optionsContainer}>
            <HtmlTooltip
              title={(
                <>
                  <Typography color="inherit">Editor Lofty Apps</Typography>
                  <em>Editor para creacion y personalizacion de paginas del proyecto</em>
                </>
              )}
              style={{display: idPageItem === idPageOrigin ? 'none' : 'block'}}
            >
              <IconButton onClick={editorSelect} className={classes.iconButtonStyle}>
                <WebIcon style={{color: 'rgba(255, 255, 255, 1)'}} />
              </IconButton>
            </HtmlTooltip>
            <HtmlTooltip
              title={(
                <>
                  <Typography color="inherit">Clonar</Typography>
                  <em>Clonar pagina del proyecto</em>
                </>
              )}
            >
              <IconButton onClick={clone} className={classes.iconButtonStyle}>
                <FileCopyOutlinedIcon style={{color: 'rgba(255, 255, 255, 1)'}} />
              </IconButton>
            </HtmlTooltip>
          </Box>
        </Box>
      </Card>
    </Box>
  );
}
